import React from "react";
import { Facet, SectionGroup, SectionGroupItem } from "../Sidebar/Filters";
import { OutletBaseCategory } from "./OutletPageResult";
import OutletBaseCategoryData from "./OutletBaseCategoryData.json";

const outletBaseCategoryData: OutletBaseCategory[] = OutletBaseCategoryData;

interface Props {
  categoryFacets: Facet;
}

const OutletBranchAndLeafCategories = ({ categoryFacets }: Props) => {
  function renderSectionGroupItems(groupItems: readonly SectionGroupItem[]) {
    return groupItems.slice(0, 4).map((subCategory: SectionGroupItem) => (
      <a
        href={subCategory.filterUrl}
        className="text-sm block leading-none mb-2 hover:underline"
      >
        {subCategory.label}
      </a>
    ));
  }

  function renderSectionGroups() {
    return categoryFacets.sectionGroups?.map(
      (category: SectionGroup) =>
        category.groupItems.length >= 2 && (
          <div className="flex flex-col px-1 md:px-6 mb-2 w-1/2 md:w-1/3 lg:w-1/3 box-border text-center">
            <img
              src={
                outletBaseCategoryData.find(
                  (baseCategory) => baseCategory.name === category.groupName
                )?.image
              }
              className="w-2/4 mx-auto"
              alt=""
            />
            <h3 className="text-base font-bold mb-0 leading-none mt-6 mb-4">
              {category.groupName}
            </h3>
            {renderSectionGroupItems(category.groupItems)}
          </div>
        )
    );
  }

  return categoryFacets.sectionGroups?.length ? (
    <div
      id="outletBranchAndLeafCategories"
      className="flex mx-auto mt-16 w-11/12 justify-center flex-wrap"
    >
      {renderSectionGroups()}
    </div>
  ) : null;
};
export default OutletBranchAndLeafCategories;
